import {
  type ChatMessageAttributes,
  type FileMessageAttributes,
  isChatMenuButtons,
  isChatMessageAttributes,
  isChatMultiProduct,
  isFileMessageAttributes,
  isMessageAttributesArray,
  type MessageAttributes,
} from '../types'

export type ChunkAttributes =
  | MessageAttributes[]
  | FileMessageAttributes
  | ChatMessageAttributes
  | null
  | undefined

/**
 * Narrow a chunk's `attributes` to the cards it actually carries. Each branch
 * additionally requires content, so a malformed row (an envelope with no files,
 * a quick-reply entry with no buttons) resolves to nothing rather than to an
 * empty card wrapper.
 */
export const resolveChatCards = (attributes: ChunkAttributes) => {
  const chatMessage = isChatMessageAttributes(attributes) ? attributes : null
  const files = isFileMessageAttributes(attributes) ? attributes : null
  const quickReplies = isMessageAttributesArray(attributes) ? attributes : null
  const menu = chatMessage && isChatMenuButtons(chatMessage.content) ? chatMessage.content : null
  const carousel =
    chatMessage && isChatMultiProduct(chatMessage.content) ? chatMessage.content : null
  return {
    files: files?.files?.length ? files : null,
    quickReplies: quickReplies?.[0]?.buttons?.length ? quickReplies : null,
    menu: menu?.message?.some((entry) => entry?.buttons?.length) ? menu : null,
    carousel: carousel?.message?.some((entry) => entry?.items?.length) ? carousel : null,
  }
}

export const hasChatAttachments = (attributes: ChunkAttributes): boolean => {
  if (!attributes) return false
  const { files, quickReplies, menu, carousel } = resolveChatCards(attributes)
  return Boolean(files || quickReplies || menu || carousel)
}
